import {ITheme} from 'contexts/ThemeContext';
import {Platform, useWindowDimensions} from 'react-native';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return {
    defaultButtonStyle: {
      justifyContent: 'center',
      alignItems: 'center',
      width: 38,
      height: 38,
      borderRadius: 100,
    },
    selectedButtonStyle: (selected: boolean) => ({
      backgroundColor: selected ? colors.cornflowerBlue : colors.purple(0.13),
    }),
    textStyle: (selected: boolean) => ({
      fontSize: 12,
      lineHeight: 18,
      color: selected ? colors.white : colors.primaryTextColor,
      ...typography.interMedium,
    }),
    ...Platform.select({
      ios: {},
      android: {},
      web: {
        defaultButtonStyle: {
          justifyContent: 'center',
          alignItems: 'center',
          width: width > 540 && width < 769 ? 38 : 48,
          height: width > 540 && width < 769 ? 38 : 48,
          borderRadius: 100,
        },
        textStyle: (selected: boolean) => ({
          fontSize: 15,
          lineHeight: 23,
          color: selected ? colors.white : colors.primaryTextColor,
          ...typography.interRegular,
        }),
      },
    }),
  };
};
